var createEnableOverlay = require('mobile/ui/createEnableOverlay')
  , tmpl = require('./tmpl.handlebars')

module.exports = createEnableOverlay(tmpl)
